import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon AccountProfileIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const AccountProfileIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 23 28">
      <path
        d="M10.9207 13.1518C14.258 13.1518 16.9634 10.4464 16.9634 7.10908C16.9634 3.77177 14.258 1.06635 10.9207 1.06635C7.58336 1.06635 4.87793 3.77177 4.87793 7.10908C4.87793 10.4464 7.58336 13.1518 10.9207 13.1518Z"
        stroke="#503291"
        strokeWidth={1.5}
      />
      <path
        d="M13.5287 26.1319H11.3746H1.06641V22.3069C1.06641 20.6681 1.85285 19.0965 3.25273 17.9378C4.65261 16.779 6.55125 16.128 8.53098 16.128H13.2183C14.0001 16.128 15.2128 16.093 15.9436 16.2873"
        stroke="#503291"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </Icon>
  )
}
export default AccountProfileIcon
